(() => {
  'use strict';

  const support = document.querySelector('[data-cbm-template]');
  if (!support) return;

  const template = support.dataset.cbmTemplate || 'unknown';
  document.documentElement.classList.add('cbm-migration-template', `cbm-migration-template--${template}`);
  if (template !== 'product') return;

  const galleryLimit = Number.parseInt(support.dataset.cbmGallerySize || '0', 10);
  const productMediaSize = Number.parseInt(support.dataset.cbmProductMediaSize || '0', 10);
  const form = document.querySelector('form[id^="product-form-"][action*="/cart/add"]');
  const display = document.querySelector('[data-cbm-tier-total]');
  const moneyFormat = support.dataset.cbmMoneyFormat || undefined;
  const currency = support.dataset.cbmCurrency || undefined;

  function selectedVariantId() {
    const idInput = form && form.querySelector('input[name="id"]');
    return idInput && idInput.value;
  }

  function selectedQuantity() {
    const input = form && form.querySelector('input[name="quantity"]');
    const quantity = input ? Number.parseInt(input.value || '1', 10) : 1;
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  function parseVariantMediaMap() {
    const mapElement = document.getElementById(support.dataset.cbmVariantMediaMap || '');
    if (!mapElement) return {};
    try {
      const parsed = JSON.parse(mapElement.textContent || '{}');
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (error) {
      support.dataset.cbmGalleryGuard = 'map-invalid';
      return {};
    }
  }

  const variantMediaMap = parseVariantMediaMap();

  function galleryRoot() {
    const mainProduct = document.querySelector('[id^="MainProduct-"]');
    if (!mainProduct) return null;
    return mainProduct.querySelector('media-gallery[id^="MediaGallery-"]:not([id$="-duplicate"])');
  }

  function nativeGalleryLists(gallery) {
    if (!gallery || !productMediaSize) return null;

    // Shrine's native product-media-gallery renders these two direct lists. They are not Splide lists.
    const viewer = gallery.querySelector(':scope > slider-component[id^="GalleryViewer-"] > ul[id^="Slider-Gallery-"]');
    const thumbnailList = gallery.querySelector(':scope > slider-component[id^="GalleryThumbnails-"] > ul[id^="Slider-Thumbnails-"]');
    const mainSlides = viewer
      ? Array.from(viewer.children).filter((slide) => slide.matches('li.product__media-item.slider__slide[data-media-id]'))
      : [];
    const thumbnailSlides = thumbnailList
      ? Array.from(thumbnailList.children).filter((slide) => slide.matches('li.thumbnail-list__item.slider__slide[data-target]'))
      : [];

    // product.media is the server-side contract. Do not touch duplicate, filtered, or partial galleries.
    if (mainSlides.length !== productMediaSize) return null;
    if (thumbnailList && thumbnailSlides.length !== productMediaSize) return null;
    const mainIds = new Set(mainSlides.map((slide) => slide.dataset.mediaId));
    if (thumbnailSlides.some((slide) => !mainIds.has(slide.dataset.target))) return null;

    return { viewer, mainSlides, thumbnailSlides };
  }

  function originalMediaPosition(slide) {
    const position = Number.parseInt(slide.dataset.cbmGalleryPosition || '', 10);
    return Number.isInteger(position) ? position : null;
  }

  function rememberNativePositions(mainSlides, thumbnailSlides) {
    const mainPositions = new Map();
    mainSlides.forEach((slide, index) => {
      if (originalMediaPosition(slide) === null) slide.dataset.cbmGalleryPosition = String(index);
      mainPositions.set(slide.dataset.mediaId, originalMediaPosition(slide));
    });
    thumbnailSlides.forEach((slide) => {
      if (originalMediaPosition(slide) !== null) return;
      const position = mainPositions.get(slide.dataset.target);
      if (Number.isInteger(position)) slide.dataset.cbmGalleryPosition = String(position);
    });
  }

  function clearGuardState(slide) {
    if (slide.dataset.cbmSourceGalleryHidden !== 'true') return;
    slide.hidden = false;
    slide.removeAttribute('aria-hidden');
    delete slide.dataset.cbmSourceGalleryHidden;
  }

  function setGuardState(slide, hidden) {
    if (!hidden) {
      clearGuardState(slide);
      return;
    }
    slide.hidden = true;
    slide.setAttribute('aria-hidden', 'true');
    slide.dataset.cbmSourceGalleryHidden = 'true';
  }

  function syncGalleryCounter(gallery, mainSlides, sourceGallerySize) {
    const visibleSlides = mainSlides.filter((slide) => !slide.hidden);
    const viewer = gallery.querySelector('slider-component[id^="GalleryViewer-"] > ul[id^="Slider-Gallery-"]');
    const viewerRect = viewer && viewer.getBoundingClientRect();
    const viewedSlide = viewerRect && viewerRect.width > 0
      ? visibleSlides.reduce((nearest, slide) => {
        const distance = Math.abs(slide.getBoundingClientRect().left - viewerRect.left);
        return !nearest || distance < nearest.distance ? { slide, distance } : nearest;
      }, null)
      : null;
    const activeSlide = viewedSlide ? viewedSlide.slide : visibleSlides.find((slide) => slide.classList.contains('is-active')) || visibleSlides[0];
    const visibleExtraCount = mainSlides.filter((slide) =>
      originalMediaPosition(slide) >= sourceGallerySize && !slide.hidden
    ).length;
    const total = sourceGallerySize + visibleExtraCount;
    const current = Math.min(Math.max(visibleSlides.indexOf(activeSlide) + 1, 1), total);

    gallery.querySelectorAll('.slider-counter--current').forEach((counter) => {
      counter.textContent = String(Math.max(current, 1));
    });
    gallery.querySelectorAll('.slider-counter--total').forEach((counter) => {
      counter.textContent = String(total);
    });
    support.dataset.cbmGalleryCounterCurrent = String(Math.max(current, 1));
    support.dataset.cbmGalleryCounterTotal = String(total);
  }

  function bindNativeGalleryEvents(gallery, viewer) {
    if (gallery.dataset.cbmGalleryGuardBound === 'true') return;
    gallery.dataset.cbmGalleryGuardBound = 'true';
    // Shrine emits this from its slider component after arrows, swipes, and native variant jumps.
    const slider = viewer.closest('slider-component');
    if (slider) slider.addEventListener('slideChanged', scheduleGalleryGuard);
  }

  function refreshNativeVisibleSlides(viewer, mainSlides) {
    const slider = viewer.closest('slider-component');
    if (!slider || typeof slider.resetPages !== 'function') return;
    const signature = mainSlides.filter((slide) => !slide.hidden).map((slide) => slide.dataset.mediaId).join('|');
    if (slider.dataset.cbmVisibleSignature === signature) return;
    slider.dataset.cbmVisibleSignature = signature;
    // Use Shrine's own cache refresh; never replace its slider, scroll position, or zoom nodes.
    slider.resetPages();
  }

  function guardGallery() {
    if (!galleryLimit || !productMediaSize) return;
    const gallery = galleryRoot();
    const lists = nativeGalleryLists(gallery);
    if (!gallery || !lists) {
      support.dataset.cbmGalleryGuard = 'unavailable';
      return;
    }

    const sourceGallerySize = Math.min(galleryLimit, productMediaSize);
    const { viewer, mainSlides, thumbnailSlides } = lists;
    rememberNativePositions(mainSlides, thumbnailSlides);
    bindNativeGalleryEvents(gallery, viewer);

    const variantId = selectedVariantId();
    const rawPosition = variantMediaMap[variantId];
    const mappedPosition = typeof rawPosition === 'number' ? rawPosition : Number.NaN;
    const activePosition = Number.isInteger(mappedPosition) && mappedPosition >= 0 && mappedPosition < productMediaSize
      ? mappedPosition
      : null;

    mainSlides.forEach((slide) => {
      const position = originalMediaPosition(slide);
      setGuardState(slide, position >= sourceGallerySize && position !== activePosition);
      if (position === activePosition && !slide.hidden) {
        slide.querySelectorAll('img[loading="lazy"]').forEach((image) => {
          image.loading = 'eager';
          image.fetchPriority = 'high';
        });
      }
    });
    thumbnailSlides.forEach((slide) => {
      const position = originalMediaPosition(slide);
      setGuardState(slide, position >= sourceGallerySize && position !== activePosition);
    });

    const activeRestored = activePosition !== null && activePosition >= sourceGallerySize ? 1 : 0;
    support.dataset.cbmGalleryGuard = 'applied';
    support.dataset.cbmGallerySlideListCount = String(thumbnailSlides.length ? 2 : 1);
    support.dataset.cbmGalleryTotalCount = String(productMediaSize);
    support.dataset.cbmGalleryVisibleCount = String(sourceGallerySize + activeRestored);
    support.dataset.cbmGalleryHiddenCount = String(productMediaSize - sourceGallerySize - activeRestored);
    support.dataset.cbmGalleryActiveMediaPosition = activePosition === null ? '' : String(activePosition);
    refreshNativeVisibleSlides(viewer, mainSlides);
    syncGalleryCounter(gallery, mainSlides, sourceGallerySize);
  }

  let galleryRefreshQueued = false;
  function scheduleGalleryGuard() {
    if (galleryRefreshQueued) return;
    galleryRefreshQueued = true;
    window.setTimeout(() => {
      galleryRefreshQueued = false;
      guardGallery();
    }, 0);
  }

  // Capture restores a post-gallery active variant image before Shrine's own change handler runs.
  document.addEventListener('change', (event) => {
    if (form && (event.target === form || form.contains(event.target))) {
      guardGallery();
      scheduleGalleryGuard();
    }
  }, true);
  document.addEventListener('input', (event) => {
    if (form && event.target && event.target.name === 'id' && form.contains(event.target)) {
      guardGallery();
      scheduleGalleryGuard();
    }
  }, true);
  if (form) {
    const variantInput = form.querySelector('input[name="id"]');
    if (variantInput && window.MutationObserver) {
      new MutationObserver(scheduleGalleryGuard).observe(variantInput, {
        attributes: true,
        attributeFilter: ['value']
      });
    }
  }
  // One initial pass and one queued post-defer pass; intentionally no subtree observer or retry loop.
  guardGallery();
  scheduleGalleryGuard();

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && moneyFormat) {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }
    if (currency && window.Intl && Intl.NumberFormat) {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency', currency
      }).format(cents / 100);
    }
    return String(cents);
  }

  function updateTierTotal() {
    if (!display) return;
    const map = window.CBMQuantityRuntimeMap || {};
    const variant = map[selectedVariantId()];
    const quantity = selectedQuantity();
    // Informational only: this never applies a code, changes the cart, or updates native tile pricing.
    if (quantity === 3 && variant && variant.enforcement === 'configured' &&
        Number.isInteger(variant.q3_total_cents) && variant.discount_id) {
      display.textContent = `3-item total: ${formatMoney(variant.q3_total_cents)}`;
      display.hidden = false;
    } else {
      display.textContent = '';
      display.hidden = true;
    }
  }

  document.addEventListener('change', () => window.setTimeout(updateTierTotal, 0), true);
  document.addEventListener('click', () => window.setTimeout(updateTierTotal, 0), true);
  updateTierTotal();

  function customFieldsFor(formElement) {
    return Array.from(document.querySelectorAll('[data-cbm-custom-input]'))
      .filter((input) => input.form === formElement);
  }

  function setCustomFieldError(input, message) {
    const error = document.getElementById(input.dataset.cbmErrorId || '');
    input.setCustomValidity(message || '');
    input.setAttribute('aria-invalid', message ? 'true' : 'false');
    if (error) {
      error.textContent = message || '';
      error.hidden = !message;
    }
  }

  function validateCustomField(input) {
    const value = input.value.trim();
    let message = '';
    if (input.required && !value) {
      message = input.dataset.cbmRequiredMessage || 'Please complete this field.';
    } else if (input.minLength > 0 && value && value.length < input.minLength) {
      message = `Please enter at least ${input.minLength} characters.`;
    }
    setCustomFieldError(input, message);
    return !message;
  }

  document.addEventListener('input', (event) => {
    const input = event.target;
    if (input && input.matches && input.matches('[data-cbm-custom-input]')) validateCustomField(input);
  }, true);

  // Shrine can set novalidate on its AJAX form. Capture-phase validation blocks only invalid submissions;
  // valid events are untouched so the native AJAX/cart flow continues normally.
  document.addEventListener('submit', (event) => {
    const submittedForm = event.target;
    if (!submittedForm || !submittedForm.matches || !submittedForm.matches('form[id^="product-form-"][action*="/cart/add"]')) return;
    const invalid = customFieldsFor(submittedForm).find((input) => !validateCustomField(input));
    if (!invalid) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    invalid.focus();
    invalid.reportValidity();
  }, true);
})();
